/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @author Jiri Moc <jiri.moc@outlook.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react"

import { Form } from "../shared/FormModel/FormModel";
import { SectionGroup } from "../shared/FormModel/elements/FormSectionGroup";
import { Section } from "../shared/FormModel/elements/FormSection";
import { Row } from "../shared/FormModel/elements/FormRow";
import { HTMLContent } from "../shared/FormModel/elements/FormHTMLContent";
import { FieldText } from "../shared/FormModel/elements/FormFieldText";
import { FieldLabel } from "../shared/FormModel/elements/FormFieldLabel";

export const form_dodatekKeSmlouve = Form({
    id: "dodatek-ke-smlouve",
    version: "2020-07-r1",
    title: "Dodatek ke smlouvě",
    icon: "book-plus-multiple",
    showInMenu: true
}, [
    // Config sekce
    SectionGroup({
        print: false
    }, [
        Section({
            id: "hodnoty-formulare",
            title: "Hodnoty pro formulář",
        }, [
            // zakaznik
            Row({}, [
                FieldText({
                    id: "objednatel-jmeno",
                    label: "Jméno objednatele"
                })
            ]),
            Row({}, [
                FieldText({
                    id: "objednatel-adresa",
                    label: "Adresa objednatele"
                })
            ]),
            Row({}, [
                FieldText({
                    id: "objednatel-email",
                    label: "Email objednatele"
                })
            ]),
            Row({}, [
                FieldText({
                    id: "objednatel-telefon",
                    label: "Telefon objednatele"
                })
            ]),
            //
            Row({}, [
                FieldText({
                    id: "misto-plneni",
                    label: "Místo plnění díla"
                })
            ])
        ]),
    ]),
    // Obsah smlouvy
    SectionGroup({}, [
        Section({
            id: "smluvni-strany",
            title: "Smluvní strany"
        }, [
            Row({}, [
                HTMLContent({}, (data) => <>
                    <table style={{
                        width: "100%"
                    }}>
                        <tr style={{
                            width: "100%"
                        }}>
                            <td style={{
                                width: "50%",
								lineHeight: "25px"
                            }}>
                                Tomáš Zimmel<br />
								Ledenická - Škarda 1252, Srubec, 370 06<br />
								IČO: 741 71 364<br />
								DIČ: CZ8503201377<br />
								tel: +420 792 313 446<br />
								e-mail: zimmel@kuchynerondo.cz, ztkuchyne@seznam.cz<br />
								dále jen jako
								"<strong style={{
                                    fontWeight: "bold"
                                }}>
                                    Zhotovitel
								</strong>"
							</td>
                            <td style={{
                                width: "50%",
								lineHeight: "25px"
                            }}>
                                <strong>{data.values["hodnoty-formulare_objednatel-jmeno"] || ""}</strong><br />
                                <strong>{data.values["hodnoty-formulare_objednatel-adresa"] || ""}</strong><br />
								tel: <strong>{data.values["hodnoty-formulare_objednatel-telefon"] || ""}</strong><br />
								e-mail: <strong>{data.values["hodnoty-formulare_objednatel-email"] || ""}</strong><br />
								dále jen jako
								"<strong style={{
                                    fontWeight: "bold"
                                }}>
                                    Objednatel
								</strong>"
							</td>
                        </tr>
                    </table>
                </>)
            ])
        ])
    ]),
    SectionGroup({}, [
        Section({
            id: "sekce-text-dodatku",
            title: "Smluvní strany uzavírají na základě vzájemné shody tento dodatek"
        }, [
            Row({
                id: "text-dodatku"
            }, [
                HTMLContent({}, (data) => <>
                    <p>
                        &nbsp;<br />
                        &nbsp;<br />
                        &nbsp;<br />
                        &nbsp;<br />
                        &nbsp;<br />
                    </p>
                </>),
            ]),
        ])
    ]),
    SectionGroup({}, [
        Section({
            id: "podpisova_sekce",
            title: "Potvrzení převzetí formuláře"
        }, [
            Row({
                id: "podpisy"
            }, [
                HTMLContent({}, (data) => <>
                    <p style={{
                        fontWeight: "bold",
                        textAlign: "center"
                    }}>
                        Obě strany prohlašují, že smlouvu podepsali svobodně, dobrovolně a jsou si vědomi všech jejich náležitostí
                    </p>
                    <table style={{
                        width: "100%"
                    }}>
                        <tr>
                            <td style={{
                                width: "50%",
                                textAlign: "center",
                                verticalAlign: "middle",
                                padding: "15px",
                                paddingTop: "50px"
                            }}
                                colSpan={2}
                            >
                                V Českých Budějovicích, dne:
                            </td>
                        </tr>
                        <tr>
                            <td style={{
                                width: "50%",
                                textAlign: "center",
                                verticalAlign: "middle",
                                padding: "15px",
                                paddingTop: "100px"
                            }}>
                                <p>
                                    . . . . . . . . . . . . . . . . . . . .
                                </p>
                                <p>
                                    <strong>Podpis a razítko<br />prodejce</strong>
                                </p>
                            </td>
                            <td style={{
                                width: "50%",
                                textAlign: "center",
                                verticalAlign: "middle",
                                padding: "15px",
                                paddingTop: "100px"
                            }}>
                                <p>
                                    . . . . . . . . . . . . . . . . . . . .
                                </p>
                                <p>
                                    <strong>Podpis<br />zákazníka</strong>
                                </p>
                            </td>
                        </tr>
                    </table>
                </>)
            ]),
        ])
    ])
]);